import styled from 'styled-components';
import Theme from '../../shared/styles/Theme';

export const Container = styled.div`
  margin: ${Theme.Size.Default};
`;
